import React, { useCallback } from 'react'
import { Autocomplete, TextField, Chip, Box } from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import { useDispatch, useSelector } from 'react-redux'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import * as rdx from '../../redux/slices/Search/input'

const AutocompleteComponent = ({
  type,
  valueList,
  onChange,
  options,
  placeholder,
  autoRef,
  ...rest
}) => {
  const dispatch = useDispatch()

  const {
    filter,
    enable: filterEnable,
    filtersList: filterList,
  } = useSelector(state => state.filterSearch)

  const handleInputChange = useCallback(
    (event, _newInputValue, reason) => {
      if (reason !== 'clear') return

      if (filter && filterEnable && filterList.length === 1) {
        dispatch(show(false))
        dispatch(codeTree(null))
        dispatch(rdx.setFilterState(true))
        dispatch(rdx.basicListInitial())
        dispatch(rdx.filterListInitial())
        dispatch(rdx.setEnabledFilter(false))
        dispatch(rdx.clearFilteredData())
      }
    },
    [dispatch, filter, filterEnable, filterList.length]
  )

  return (
    <Autocomplete
      ref={autoRef}
      id={`autocomplete-search-${type}`}
      name={`searchBy${type}`}
      limitTags={10}
      size="small"
      value={valueList}
      onChange={onChange}
      options={options}
      clearText="Limpiar"
      openText="Abrir"
      closeText="Cerrar"
      noOptionsText="No es una opción"
      onInputChange={handleInputChange}
      getOptionLabel={option => option?.title ?? ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => <TextField {...params} placeholder={placeholder} />}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...chipProps } = getTagProps({ index })
          return (
            <Chip
              key={`chip-${key}-${type}-${index}`}
              variant="outlined"
              label={option.title}
              size="small"
              deleteIcon={valueList.length > 1 ? <CancelIcon /> : <Box />}
              {...chipProps}
            />
          )
        })
      }
      {...rest}
    />
  )
}

export default React.memo(AutocompleteComponent)
